import moment from "moment";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import { FieldLabel } from "../FieldLabel";
import { Form } from "../Form";
import { FORM_FIELD } from "./form-config";
import "react-datepicker/dist/react-datepicker.css";

export const ContractLengthForm = ({ onSubmit, onSetFieldValue, values }) => {
  const handleChange = (e, { value }) => {
    onSetFieldValue(e.target.name, value);
  };

  return (
    <Form id="contract-length-form" onSubmit={onSubmit}>
      <Form.Field width={8} className="is-bottom-margined-large">
        <FieldLabel htmlFor="start-date">Contract start date</FieldLabel>
        <br />
        <DatePicker
          customInput={
            <Form.Input
              id="start-date"
              icon="calendar outline"
              iconPosition="left"
              fluid
            />
          }
          placeholderText="MM/DD/YYYY"
          name={FORM_FIELD.START_DATE}
          selected={values[FORM_FIELD.START_DATE]}
          onChange={(date) =>
            handleChange(
              { target: { name: FORM_FIELD.START_DATE } },
              { value: date }
            )
          }
          dateFormat="MM/dd/yyyy"
        />
      </Form.Field>
      <Form.Field width={8} className="is-bottom-margined-large">
        <FieldLabel htmlFor="end-date">Contract end date</FieldLabel>
        <br />
        <DatePicker
          customInput={
            <Form.Input
              id="end-date"
              icon="calendar outline"
              iconPosition="left"
              fluid
            />
          }
          placeholderText="MM/DD/YYYY"
          name={FORM_FIELD.END_DATE}
          selected={values[FORM_FIELD.END_DATE]}
          onChange={(date) =>
            handleChange(
              { target: { name: FORM_FIELD.END_DATE } },
              { value: date }
            )
          }
          dateFormat="MM/dd/yyyy"
          minDate={moment(values[FORM_FIELD.START_DATE])
            .add(1, "days")
            .toDate()}
        />
      </Form.Field>
      <Form.Field>
        <FieldLabel htmlFor="description">Description/comments</FieldLabel>
        <Form.TextArea
          id="description"
          name={FORM_FIELD.DESCRIPTION}
          value={values[FORM_FIELD.DESCRIPTION]}
          onChange={handleChange}
        />
      </Form.Field>
    </Form>
  );
};

ContractLengthForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onSetFieldValue: PropTypes.func.isRequired,
  values: PropTypes.shape({}).isRequired,
};
